import { render, staticRenderFns } from "./DashboardFeedbackURLCode.vue?vue&type=template&id=868f5058&scoped=true&"
import script from "./DashboardFeedbackURLCode.vue?vue&type=script&lang=js&"
export * from "./DashboardFeedbackURLCode.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFeedbackURLCode.vue?vue&type=style&index=0&id=868f5058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868f5058",
  null
  
)

export default component.exports